<template>
  <li class="footnote" v-if="fields && fields.link">
    <sc-link v-if="fields && fields.link" :field="fields.link" class="link" />
  </li>
</template>

<script>
import { Link } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Healthcare-Graphic-Footnote',
  components: {
    ScLink: Link
  },
  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>
<style lang="scss" scoped>
.footnote {
  list-style-type: decimal !important;
  font-size: 1.4rem;
  line-height: 1.8rem;
  margin: 0 2rem 0.5rem 3rem !important;
  padding-left: 0 !important;

  &:before {
    display: none;
  }

  &::marker {
    font-weight: 600;
    color: $dark-blue;

    font-size: 1.4rem;
  }

  .link {
    position: relative;
    font-size: 1.4rem;
    line-height: 1.8rem;

    &:after {
      content: '';
      display: inline-block;
      position: relative;
      background-image: url(~@/assets/images/icon-external-link.svg);
      background-repeat: no-repeat;
      background-size: contain;
      margin-left: 0.5rem;
      width: 1.4rem;
      min-width: 1.4rem;
      height: 1.4rem;
      min-height: 1.4rem;
      top: 0.2rem;
    }
  }
}
</style>
